import React, { useState, useEffect } from "react";

//package import

import { Backdrop, CircularProgress, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ActionCableProvider } from "react-actioncable-provider";

//user import

import { DistrictAdminLayout } from "../../layouts";
import { district_Context } from "../../context";
import { StorageKeys } from "../../Services/Storage";
import { DISTRICTS_API_ULRS, API_WS_ROOT } from "../../Services/Routes/API";
import { RoutesUrls } from "../../Services/Routes/APP";
import { headersPost } from "../../Services/API";

//portal

const DistrictAdminPortal = (props) => {
	//hooks

	const navigate = useNavigate();
	const theme = useTheme();

	//constants

	const Provider = district_Context.Provider;
	//provinces
	const [districts, setDistrics] = useState([]);
	const [open, setOpen] = useState(false);

	const token = localStorage.getItem(StorageKeys?.token);

	//

	useEffect(() => {
		getDistricts();
	}, []);

	//get provinces

	const getDistricts = () => {
		const data = {
			page: 1,
			per_page: 50,
		};
		setOpen(true);

		headersPost(DISTRICTS_API_ULRS.GET_ALL_POU, data)
			.then((res) => {
				setOpen(false);
				if (res?.status === 200 && res?.data?.success) {
					setDistrics(res?.data?.hospitals);
					// setTotalCount(res?.data?.total_count);
				} else {
					// setAlertOpen(true);
					// setAlertMsg(res?.data?.message);
					// setAlertIcon("warning");
				}
			})
			.catch((err) => {
				setOpen(false);
				const { response } = err;
				if (response?.status === 401) {
					localStorage.clear();
					navigate(RoutesUrls?.root);
				} else {
					// setAlertOpen(true);
					// setAlertMsg(response?.statusText);
					// setAlertIcon("error");
				}
			});
	};

	return (
		<Provider
			value={{
				hospitals: districts,
				user: { ...token },
			}}
		>
			<ActionCableProvider url={API_WS_ROOT + `?token=${token}`}>
				<DistrictAdminLayout {...props} />
			</ActionCableProvider>
			<Backdrop
				sx={{
					zIndex: theme.zIndex.drawer + 1,
					color: theme.palette.primary.main,
				}}
				open={open}
			>
				<CircularProgress color="inherit" />
			</Backdrop>
		</Provider>
	);
};

export default DistrictAdminPortal;
